import { FC, useState } from 'react';
import { useMethods } from '@lhb/hook';
import { downloadFile } from '@lhb/func';
import { post } from '@/common/request';
import styles from './index.module.less';
import { Button, message } from 'antd';
import V2Drawer from '@/common/components/Feedback/V2Drawer';
import V2Title from '@/common/components/Feedback/V2Title';
import LeftContent from './LeftContent';
import RightContent from './RightContent';

/**
 * @Description 收藏夹列表
 */
const Collect: FC<{
  requirementId, // 需求id
  open,
  setOpen,
}> = ({
  requirementId,
  open,
  setOpen,
}) => {

  const [loading, setLoading] = useState(false);
  const [leftKey, setLeftKey] = useState(''); // 收藏夹id
  const [folderNum, setFolderNum] = useState({
    // clusterNum: 0,
    siteLocationNum: 0,
    siteLocationFlag: false,
    name: ''
  });
  const [isRefresh, setRefresh] = useState(false);

  const methods = useMethods({

    // 添加至LCN
    addLCN() {
      if (!leftKey) {
        message.warning('请选择收藏夹');
        return;
      }
      const params = {
        requirementId,
        favoriteId: leftKey, // 收藏夹id
      };
      setLoading(true);
      // https://yapi.lanhanba.com/project/602/interface/api/75354
      post('/lcn/recommend/recommendSpotBatch', params, { isMock: false, mockId: 602, mockSuffix: '/api' }).then(() => {
        message.success('添加成功');
      }).finally(() => setLoading(false));
    },

    /**
     * @description 导出收藏列表
     */
    exportCollect: () => {
      if (!leftKey) {
        message.warning('请选择收藏夹');
        return;
      }
      setLoading(true);
      // https://yapi.lanhanba.com/project/546/interface/api/70230
      post('/clusterLocationFavor/export', { id: leftKey, requirementId }).then((res) => {
        if (res.url) {
          downloadFile({
            name: res?.name,
            url: res.url,
          });
          // window.open(`${res.url}?attname=${res.name}`);
        }
      }).finally(() => setLoading(false));
    },

  });

  return (
    <>
      <V2Drawer bodyStyle={{ padding: 0 }} open={open} onClose={() => setOpen(false)}>
        <div className={styles.collectWrap}>
          <V2Title text='收藏列表'
            className={styles.collectTitle}
            extra={<div style={{ display: 'flex' }}>
              <Button type='primary' disabled={loading} onClick={methods.addLCN}>添加至LCN</Button>
              <Button disabled={loading} className='ml-12' onClick={methods.exportCollect}>一键导出</Button>
            </div>}
          />
          { !!open && (
            <div className={styles.collectContent}>
              <LeftContent
                requirementId={requirementId}
                open={open}
                leftKey={leftKey}
                setLeftKey={setLeftKey}
                folderNum={folderNum}
                setFolderNum={setFolderNum}
                isRefresh={isRefresh}
                setRefresh={setRefresh}
              />
              { !!leftKey && <RightContent requirementId={requirementId} leftKey={leftKey} folderNum={folderNum} setRefresh={setRefresh} /> }
            </div>
          ) }
        </div>
      </V2Drawer>
    </>
  );
};

export default Collect;
